import {useQuery} from "@tanstack/react-query";

import {ParamsOptions, QueryOptions} from "@/src/modules/core/types";

import {shiftsService} from "../services";

export const shiftCoverageQueryKey = (options: ParamsOptions = {}) =>
  ["shift-coverage", options] as const;

export default function useShiftCoverage(
  _options = {} as ParamsOptions,
  queryOptions: QueryOptions = {},
) {
  const options = {..._options};

  const query = useQuery({
    queryKey: queryOptions.queryKey ?? shiftCoverageQueryKey(options),
    queryFn: () => shiftsService.getShiftCoverage(options),
    gcTime: 0,
    refetchOnWindowFocus: (queryOptions.refetchOnWindowFocus as boolean) ?? false,
    refetchOnMount: (queryOptions.refetchOnMount as boolean | "always") ?? true,
    staleTime: (queryOptions?.staleTime as number) ?? 0,
    enabled: (queryOptions as {enabled?: boolean}).enabled ?? true,
  });

  const shiftCoverage = query.isSuccess ? (query.data?.shiftCoverage ?? []) : [];
  const totalRecords = query.isSuccess ? (query.data?.meta?.total_count ?? query.data?.meta?.total ?? 0) : 0;

  return {...query, shiftCoverage, totalRecords};
}
